import { pagosAPI } from "./config";

// Obtener el estado de la suscripción del usuario
export const obtenerEstadoSuscripcion = async () => {
  try {
    const response = await pagosAPI.get("estado-suscripcion/");
    return response.data;
  } catch (error) {
    console.error("Error obteniendo estado de suscripción:", error);
    throw error;
  }
};

// Crear una sesión de checkout para contratar un plan
export const crearCheckout = async (plan) => {
  try {
    const response = await pagosAPI.post("crear-checkout/", { plan });
    return response.data;
  } catch (error) {
    console.error("Error creando checkout:", error);
    throw error;
  }
};

// Verificar si el usuario tiene acceso a funcionalidades premium
export const verificarAcceso = async () => {
  try {
    const response = await pagosAPI.get("estado-acceso/");
    return response.data;
  } catch (error) {
    console.error("Error verificando acceso:", error);
    throw error;
  }
};